import { Box, useTheme } from '@mui/material';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import { LiveDot, OUTCOME_STYLE, Pill } from './FootballCard';
import {
  FINISHED,
  LIVE_STATUS,
  SportsEvent,
  kickOff,
  resultFor,
} from './useUnitedFixtures';

// Sits inside the "Sport & Games" toggle, so a match day shows even while the
// News face is in front. Smaller than the card's pills to keep the toggle slim.
const chipSx = { height: 18, px: 0.75, gap: 0.5, fontSize: 10.5, ml: 0.75 };

const MatchDayChip = ({ event }: { event: SportsEvent }) => {
  const mode = useTheme().palette.mode;
  const status = event.strStatus ?? '';
  const result = resultFor(event);

  if (LIVE_STATUS[status]) {
    return (
      <Pill sx={{ ...chipSx, bgcolor: '#dc2626', color: '#fff' }}>
        <LiveDot />
        {result.ours}–{result.theirs}
      </Pill>
    );
  }

  if (FINISHED.includes(status)) {
    const outcome = result.outcome as keyof (typeof OUTCOME_STYLE)['dark'];
    return (
      <Pill sx={{ ...chipSx, ...OUTCOME_STYLE[mode][outcome] }}>
        FT {outcome} {result.ours}–{result.theirs}
      </Pill>
    );
  }

  return (
    <Pill
      sx={{
        ...chipSx,
        bgcolor: 'rgba(255,47,146,0.16)',
        color: mode === 'dark' ? '#ff7ab8' : '#c2185b',
      }}
    >
      <Box
        component={SportsSoccerIcon}
        sx={{ fontSize: 12, display: { xs: 'none', sm: 'block' } }}
      />
      {kickOff(event).toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
      })}
    </Pill>
  );
};

export default MatchDayChip;
